import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-channelconfiguration",
  "use": "icon-soc-m-channelconfiguration-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-channelconfiguration\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"300\" cy=\"180\" r=\"28\" /><rect x=\"192\" y=\"288\" width=\"288\" height=\"448\" rx=\"32\" /><rect x=\"544\" y=\"288\" width=\"288\" height=\"448\" rx=\"32\" /><path d=\"M480 448h64v128h-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-channelconfiguration.svg
// module id = UvI+
// module chunks = 492